import dictsApi from "@/api/app/dicts/dicts";
import fieldUtils from "./fieldUtils";

let dicData = {};
let code2fields = {};
let code2field2value = {};
let code2value2value = {};

const getData = () => fieldUtils.getValueDef(dicData, {});
const getList = () => fieldUtils.getValueDef(getData().data, []);

const reload = async () => {
    let data = await dictsApi.getList();
    dicData = data ? data : {};
    let list = getList();
    {
        let _code2fields = {};
        list.forEach(x => _code2fields[x.code] = x);
        code2fields = _code2fields;
    }
    {
        let _code2field2value = {};
        let _code2value2value = {};
        list.forEach(x => {
            let field2value = _code2field2value[x.code];
            field2value = field2value ? field2value : {};

            let value2value = _code2value2value[x.code];
            value2value = value2value ? value2value : {};

            if (x.value) {
                x.value.forEach(y => {
                    field2value[y.code] = y;
                    value2value[y.value] = y;
                });
            }

            _code2field2value[x.code] = field2value;
            _code2value2value[x.code] = value2value;
        });
        code2field2value = _code2field2value;
        code2value2value = _code2value2value;
    }
}


const getFields = (code) => {
    return fieldUtils.getFieldValue(code2fields, [code], {});
}

const getFieldsValue = (code) => {
    return fieldUtils.getFieldValue(code2fields, [code, 'value'], []);
}

const getField = (code, field) => {
    return fieldUtils.getFieldValue(code2field2value, [code, field], {});
}

const getFieldValue = (code, field, def) => {
    def = def ? def : field;
    return fieldUtils.getFieldValue(code2field2value, [code, field, 'value'], def);
}

const getOptions = (code, fields) => {
    fields = fields ? fields : [];
    let res = getFieldsValue(code);

    if (fields.length > 0) {
        return fields.map(x => ({ value: x, label: getFieldValue(code, x) }));
    } else {
        return res.map(x => ({ label: x.value, value: x.code }));
    }
}

const getFiledByValue = (code, value) => {
    return fieldUtils.getFieldValue(code2value2value, [code, value], {});
}

export default {
    getData,
    getList,
    reload,
    getFields,
    getFieldsValue,
    getField,
    getFieldValue,
    getOptions,
    getFiledByValue,
}

